import React, { useCallback, useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import { PapiroConsole } from "src/utils/papiroConsole";

import { Box, Card, CardContent, Grid, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/styles";

const CustomImage = styled("img")(({ isLoaded }) => ({
    maxWidth: '80%',
    maxHeight: '60%',
    objectFit: 'contain',
    objectPosition: "center",
    opacity: isLoaded ? 1 : 0,
    transition: "opacity 0.3s ease-in-out",
    zIndex: 1,
}));

const BlockCard = (props) => {

    const { block, openKnowledgeBaseDialog } = props

    const [src, setSrc] = useState('')
    const [imageLoaded, setImageLoaded] = useState(false)

    let history = useHistory()

    const handleLoad = useCallback(() => {
        setImageLoaded(true);
    }, []);

    const getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                setSrc(ImageData.data)
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        } finally {
            setImageLoaded(false)
        }
    }

    const getLanguage = () => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"
        return language
    }

    const getHref = () => {
        switch (block.clientportalblocktype) {
            case 1:
                return '#'
            case 2:
                return `/${getLanguage()}/article-external/${block.articleid}`
            case 3:
                return block.link
            case 4:
                return `/${getLanguage()}/news-section/${block.articlesectionid}`
            default:
                return '#'
        }
    }

    const handleClick = async (e) => {
        e.preventDefault()
        switch (block.clientportalblocktype) {
            case 1:
                openKnowledgeBaseDialog(block.knowledgebaseid)
                break

            case 2:
                history.push(`/${getLanguage()}/article-external/${block.articleid}`)
                break

            case 3:
                window.open(`${block.link}`, block.linktargetisself ? '_self' : '_blank')
                break

            case 4:
                history.push(`/${getLanguage()}/news-section/${block.articlesectionid}`)
                break
        }
    }

    useEffect(async () => {
        if (block.image) {
            getFile(block.image)
        }
    }, [block])

    return (
        <Grid item key={block.id} xs={12} sm={6} md={4} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card
                component="a"
                href={getHref()}
                onClick={handleClick}
                target={block.clientportalblocktype === 3 && !block.linktargetisself ? '_blank' : undefined}
                rel={block.clientportalblocktype === 3 && !block.linktargetisself ? 'noopener noreferrer' : undefined}
                sx={{ width: 250, height: 180, cursor: "pointer", textDecoration: "none", color: "inherit", "&:hover": { textDecoration: "none" } }}
            >
                <CardContent sx={{ flexGrow: 1, p: 3, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Box
                        sx={{
                            width: "15vw",
                            height: "5vw",
                            bgcolor: 'primary.lighter',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2,
                            position: 'relative',
                        }}
                    >
                        {block.image && (
                            <>
                                {!imageLoaded && (
                                    <Skeleton
                                        variant="circular"
                                        width="80px"
                                        height="80px"
                                        sx={{ borderRadius: 1, position: 'absolute', zIndex: 2 }}
                                    />
                                )}
                                <CustomImage
                                    src={src}
                                    alt={block.title}
                                    loading="lazy"
                                    decoding="async"
                                    isLoaded={imageLoaded}
                                    onLoad={handleLoad}
                                />
                            </>
                        )}
                    </Box>

                    <Typography variant="h6" component="h3" gutterBottom textAlign="center">
                        {block.title}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default BlockCard;